import type { FormField } from '@cli-types/core-engine/schema.js'
import { escapeAttribute, escapeJsx, jsString } from '@cli-utils/text.js'
import { renderMultiselectFieldJsxFieldControllerTemplate } from '@next-adapter/templates/renderers/generators/form-pipeline/form-component-shared/generate-multiselect-field-jsx.js'
import { errorMessageLine } from './error-message-line.js'
import { fieldContainerClass } from './field-container-class.js'
import { formLabelWithDescriptionLine } from './form-label-with-description-line.js'
import { selectClass } from './select-class.js'

export function generateMultiselectFieldJSX(
  field: FormField,
  name: string,
  label: string,
  hintJSX: string,
  requiredStar: string
): string {
  const optionItems = (field.options || [])
    .map(
      (opt) =>
        `                <option value="${escapeAttribute(opt.value)}">${escapeJsx(opt.label)}</option>`
    )
    .join('\n')
  return renderMultiselectFieldJsxFieldControllerTemplate({
    name: name,
    fieldContainerClass: fieldContainerClass(field.height),
    formLabelWithDescriptionLine: formLabelWithDescriptionLine(
      name,
      label,
      requiredStar,
      hintJSX,
      '              '
    ),
    selectClass: selectClass(field.height),
    optionItems: optionItems,
    errorMessageLine: errorMessageLine(jsString(name), '              ')
  })
}
